import { faInfoCircle, faSparkles } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { InfoTooltip } from '@karnov/kui-react'

import { FC } from 'react'

import { useTranslation } from 'services/i18n'

export const ReferenceSummaryDecorator: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation.references_panel.ai_generated_summary',
  })

  return (
    <div className="flex flex-row items-center justify-between text-sm font-medium">
      <div className="flex flex-row items-center gap-2">
        <FontAwesomeIcon icon={faSparkles} />
        {t('text')}
      </div>
      <InfoTooltip content={t('tooltip')}>
        <FontAwesomeIcon icon={faInfoCircle} />
      </InfoTooltip>
    </div>
  )
}
